<template>
  <div id="ManagerSupport">
    <div class="container">
      <h3 class="mt-5">Manager support</h3>
      <div class="contentGrid mt-5">
        <div
          id="referralText"
          class="pb-3 d-flex flex-column justify-content-between"
        >
          <h4 class="mt-2">Manager referral</h4>
          <p class="mt-3">
            If you're seeing that one of your employees is struggling with their
            their mental health or other challenges, you may want to refer the
            service for support. A referral not only enables you to your
            employee to the appropriate experts, but it also helps them feel
            supported.
          </p>
          <b-button
            class="msButton"
            variant="cta"
            squared
            @click="goToReferral"
          >
            Get started <span class="ml-4"> > </span>
          </b-button>
        </div>
        <div id="referralImage" class="position-relative">
          <img
            src="https://media.spectrum.life/assets/axa/manager_tile.jpg"
            alt="woman using computer"
          />
        </div>
        <div id="eapImage" class="position-relative">
          <img
            src="https://media.spectrum.life/assets/axa/mgr-support.jpg"
            alt="man using computer"
          />
        </div>
        <div
          id="eapText"
          class="pb-3 d-flex flex-column justify-content-between"
        >
          <h4 class="mt-2">
            Employee assistance programme (EAP) - support with everyday
            challenges
          </h4>
          <ul class="mt-3">
            <li>
              A mental health worry - anxiety, stress, family or relationship
              matters
            </li>
            <li>
              A financial or legal worry - if you're experiencing low mood and
              need financial or legal support, our Life Management service gives
              you practical, impartial guidance on concerns including on
              concerns including home and family issues, such as buying a house,
              debt management, or tenants' rights.
            </li>
          </ul>
          <b-button class="msButton" variant="cta" squared @click="goToEAP">
            Access your EAP <span class="ml-4"> > </span>
          </b-button>
        </div>
      </div>
    </div>
    <ManagerSupportContent />
  </div>
</template>

<script>
import ManagerSupportContent from "@/components/ManagerSupportContent.vue";

export default {
  name: "ManagerSupport",
  components: { ManagerSupportContent },
  data() {
    return {
      page: 1
    };
  },
  methods: {
    goToReferral() {
      this.$router.push("/manager-support-referral");
    },
    goToEAP() {
      this.$router.push("/dmh");
    }
  }
};
</script>

<style lang="less">
#ManagerSupport {
  overflow-x: hidden;
  background-color: #fafafa !important;
  h3 {
    font-size: 2.5em;
  }
  p,
  ul {
    font-size: 1.6em;
  }
  .contentGrid {
    display: grid;
    margin: auto;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 32px;
    grid-column-gap: 16px;
    div {
      min-height: 250px;

      h4 {
        font-size: 2em;
      }
      img {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      a {
        border-radius: 10px;
        width: 110px;
      }
    }
  }
  #referralImage,
  #eapImage {
    min-height: 300px;
  }
  .msButton {
    width: 200px;
    align-self: flex-end;
  }

  #pageNumber {
    display: none !important;
  }

  @media (min-width: 1200px) {
    .container {
      max-width: 960px !important;
    }
  }
  @media (max-width: 576px) {
    .contentGrid {
      grid-template-columns: 1fr;
      div {
        min-height: 150px;
      }
      #eapImage {
        grid-row: 4;
      }
    }
  }
}
</style>
